<template>
  <div class="baseBox">
    <div class="left-img"><img src="@/assets/shouyequesheng.svg" alt=""></div>
      <div class="right-btn">
        <h3>{{$t('credentials_非常抱歉，您无权访问该页面')}}</h3>
        <p>{{$t('credentials_非常抱歉，您可以联系企业管理员为您开通权限')}}</p>
        <a-button type="primary" @click="goToPage">{{$t('common_btn_immediately_openedDocument')}}<img src="@/assets/letseewhite.svg" style="margin-left: 4px;" /></a-button>
      </div>
  </div>
</template>

<script>
export default {
  methods: {
    /**
     * 跳转到帮助中心
     */
    goToPage () {
      this.$router.push({
        path: '/documentCenter?docId=310&catId=0-175-175,0-171'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.baseBox {
  width: 100%;
  padding: 73px 0 76px 0;
  display: flex;
  .left-img {
      width: 50%;
      text-align: right;
      img {
        margin-right: 30px;
      }
  }
  .right-btn {
    width: 50%;
    border-left: 2px solid #E8E8E8;
    padding: 2px 0 29px 42px;
    h3 {
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 21px;
    }
    p {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      line-height: 22px;
      margin-top: 12px;
      margin-bottom: 24px;
    }
    .sso-ant-btn {
      display: flex;
      align-items: center;
      min-width: 92px;
      background: #077BFC;
      border-radius: 2px;
      font-size: 12px;
      padding-right: 7px;
      padding-left: 12px;
      &:hover {
        background: #60ABFF;
      }
    }
  }
}
</style>
